import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5475d14e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMouseenter", "onMouseleave"]
const _hoisted_2 = { class: "item" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more-arrow" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "submenu"
}
const _hoisted_6 = ["exit-focus-box", "onClick"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "check" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = {
  key: 0,
  class: "shortcut"
}
const _hoisted_11 = {
  key: 0,
  class: "section-divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContextMenuListing = _resolveComponent("ContextMenuListing", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: "context-menu-listing-control",
    style: _normalizeStyle(_ctx.offset),
    onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "section",
        key: section.id
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.text
          }, [
            (item.type === _ctx.MenuType.Submenu)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass({ disabled: item.disabled }),
                  onMouseenter: ($event: any) => (_ctx.submenuEnter(item)),
                  onMouseleave: ($event: any) => (_ctx.submenuLeave(item))
                }, [
                  _createElementVNode("a", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(item.text), 1),
                    _hoisted_4
                  ]),
                  (_ctx.isActive(item))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_ContextMenuListing, {
                          root: false,
                          sections: item.sections,
                          on_select: _ctx.onChildItemSelect
                        }, null, 8, ["sections", "on_select"])
                      ]))
                    : _createCommentVNode("", true)
                ], 42, _hoisted_1))
              : (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: _normalizeClass({ disabled: item.disabled }),
                  "exit-focus-box": !item.keepMenuOpenOnSelect,
                  onClick: ($event: any) => (_ctx.onItemClick(item))
                }, [
                  _createElementVNode("a", {
                    class: "item",
                    href: item.disabled ? null : item.link,
                    target: "_blank"
                  }, [
                    _withDirectives(_createElementVNode("span", _hoisted_8, " ✓ ", 512), [
                      [_vShow, item.value]
                    ]),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.text), 1),
                    (item.shortcut)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.formatShortcut(item.shortcut)), 1))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_7)
                ], 10, _hoisted_6))
          ], 64))
        }), 128)),
        (i < _ctx.sections.length - 1)
          ? (_openBlock(), _createElementBlock("a", _hoisted_11))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 36))
}